export default __webpack_public_path__ + "static/media/logo.5980f1e2.svg";